module.exports = __webpack_public_path__ + "static/media/circle_filled_blue.fe73ed4e.svg";